<template>
  <v-app>
    <template v-if="!$vuetify.breakpoint.xsOnly">
      <v-navigation-drawer
        v-model="drawer"
        app
        clipped
        right
        temporary
        class="mt-12"
      >
        <v-list nav dense>
          <v-list-item-group active-class="deep-purple--text text--accent-4">
            <v-list-item link to="/about">
              <v-list-item-icon>
                <v-icon>mdi-information</v-icon>
              </v-list-item-icon>
              <v-list-item-title>About</v-list-item-title>
            </v-list-item>
            <template v-if="currentUser">
              <v-list-item link to="/">
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{
                  currentUser.displayName || currentUser.p
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item link to="/logout">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-item link to="/login">
                <v-list-item-icon>
                  <v-icon>mdi-login</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Sign in</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </template>
    <v-app-bar app dark dense color="primary" style="z-index: 2000">
      <div>
        <img
          src="@/assets/logo.png"
          style="border-radius: 10%; margin-right: 10px; height:40px;
                margin-top: 5px; margin-bottom: 0px;"
        />
      </div>
      <v-toolbar-title>SAFE Ormoc</v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="!$vuetify.breakpoint.xsOnly">
        <v-btn icon @click="drawer = true">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
    </v-app-bar>
    <v-content>
      <router-view />
      <v-snackbar v-model="snackWithButtons" :timeout="timeout" bottom left>
        {{ snackWithBtnText }}
        <v-spacer />
        <v-btn dark text color="#00f500" @click.stop="refreshApp">
          {{ snackBtnText }}
        </v-btn>
        <v-btn dark icon @click="snackWithButtons = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-content>
    <template v-if="$vuetify.breakpoint.xsOnly">
      <v-bottom-navigation
        app
        v-model="activeBottomNav"
        active-class="highligh-bt deep-purple--text text--accent-4"
      >
        <template v-if="currentUser">
          <v-btn value="/" @click.stop="navigate('/')" fab>
            <span>Profile</span>
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-btn value="/about" @click.stop="navigate('/about')" fab>
          <span>About</span>
          <v-icon>mdi-information</v-icon>
        </v-btn>
        <template v-if="currentUser">
          <v-btn value="/logout" @click.stop="navigate('/logout')" fab>
            <span>Logout</span>
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn value="/login" @click.stop="navigate('/login')" fab>
            <span>Sign in</span>
            <v-icon>mdi-login</v-icon>
          </v-btn>
        </template>
      </v-bottom-navigation>
    </template>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    drawer: false,
    activeBottomNav: "",
    refreshing: false,
    registration: null,
    snackBtnText: "",
    snackWithBtnText: "",
    snackWithButtons: false,
    timeout: 0
  }),
  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },
  watch: {
    $route: "activateBottomNav"
  },
  computed: {
    currentUser() {
      return this.$root.user;
    }
  },
  methods: {
    activateBottomNav() {
      this.activeBottomNav = this.$route.path;
    },
    navigate(path) {
      let vm = this;
      vm.$router.push({ path: path }).catch(err => {
        err;
      });
    },
    showRefreshUI(e) {
      // Display a snackbar inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;
      this.snackBtnText = "Refresh";
      this.snackWithBtnText = "New version available!";
      this.snackWithButtons = true;
    },
    refreshApp() {
      this.snackWithButtons = false;
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");
    }
  }
};
</script>
<style lang="sass" scoped>
.v-bottom-navigation
  .highligh-bt
    border-top-style: solid!important
    border-top-color: #6200ea!important
    top: -2px
</style>
